import { getExternalServers } from './auth';

export const getServers = () => {
  return getExternalServers();
};
